// src/components/FloatingButtons.jsx
import React from "react";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa";
import "../Css/FloatingButtons.css";

const FloatingButtons = () => {
  return (
    <>
      {/* CALL BUTTON */}
      <a
        href="tel:+917304398067"
        className="floating-btn call-btn"
        aria-label="Call Now"
      >
        <FaPhoneAlt />
        <span className="shine"></span>
      </a>

      {/* WHATSAPP BUTTON */}
      <a
        href="https://wa.me/917304398067"
        target="_blank"
        rel="noopener noreferrer"
        className="floating-btn whatsapp-btn"
        aria-label="WhatsApp Chat"
      >
        <FaWhatsapp />
        <span className="shine"></span>
      </a>
    </>
  );
};

export default FloatingButtons;
